<template>
  <div class="login-container" v-if="onShow">
    <div>
      <img
        src="../assets/Rateio_Indireto_Login.png"
        width="136px"
        height="200px"
      />
      <p></p>
      <div id="signin_button"></div>
      <p class="user-login__error" v-if="error">{{ error }}</p>
    </div>
  </div>
</template>

<style>
.el-button {
  background: #e87305;
  padding-top: 8px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 8px;
  color: #fff;
  font-weight: bold;
  font-size: 12px;
}

.el-button:hover {
  background: #c76000;
  color: #fff;
}

.el-button:focus {
  background: #e87305;
  color: #fff;
}

.el-button:disabled {
  background: #e87305;
  opacity: 0.5;
}

.el-button:disabled:hover {
  background: #e87305;
  opacity: 0.5;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";

export default {
  name: "Login",
  data() {
    return {
      clientId: process.env.VUE_APP_CLIENT_GOOGLE_ID,
      isDisabled: false,
      error: false,
      onShow: true,
    };
  },
  methods: {
    ...mapActions(["doLogin"]),
    loginSubmit() {
      this.isDisabled = true;
    },
    async onSuccess({ credential: token }) {
      const { data } = await axios.get(
        `https://www.googleapis.com/oauth2/v3/tokeninfo?id_token=${token}`
      );
      const authorizedDomains = ["navitdigital.com.br", "cesar.org.br"];
      let status;

      await axios
        .get(`${process.env.VUE_APP_API_LINK}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .catch((error) => {
          status = error.response.status;
        });

      if (!authorizedDomains.includes(data.hd) || status === 403) {
        this.isDisabled = false;
        this.error = "Usuário não autorizado!";
      } else {
        await this.doLogin({
          tokenId: token,
          userName: data.name,
        });
        this.$message({
          type: "success",
          message: "Login realizado com sucesso!",
        });
        this.isDisabled = false;
      }
    },
    onFailure() {
      this.isDisabled = false;
    },
  },
  mounted() {
    let googleScript = document.createElement("script");
    googleScript.src = "https://accounts.google.com/gsi/client";
    googleScript.async = true;
    document.head.appendChild(googleScript);

    window.addEventListener("load", () => {
      window.google.accounts.id.initialize({
        client_id: this.clientId,
        callback: this.onSuccess,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("signin_button"),
        { theme: "outline", size: "large" }
      );
    });
  },
};
</script>

<style scoped>
.login-container {
  background-color: #f8f8f8;
  margin: 0;
  position: absolute;
  top: 40%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  text-align: center;
  height: 450px;
  padding: 30px;
  width: 500px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  align-content: center;
  display: flex;
  flex-direction: row;
  transition: visibility 0s, opacity 0.3s linear;
}

.user-login__error {
  color: #ff5f54;
  margin-top: 15px;
  text-align: center;
  font-size: 14px !important;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
